"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ManagerSearchButton = styled_components_1.default.button `
  height: 28px;
  margin-left: 2px;
  width: 70px;
  background-color: rgb(75, 140, 247);
  border-color: rgb(48, 121, 237);
  border-radius: 4px;
  border-width: 1px;
  cursor: pointer;

  position: relative;
  img {
    position: absolute;
    top: 25%;
    left: 40%;
  }
`;
//# sourceMappingURL=search-button.js.map